module.exports = __webpack_public_path__ + "static/media/mediumThumbOffPlanMeal.29947476.jpg";